<input
  type="text"
  [placeholder]="placeholder"
  [maxLength]="maxLength"
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  (keyup.enter)="onSubmit()"
/>
